import { createGlobalStyle } from 'styled-components';
import theme from '../theme';

const GlobalStyle = createGlobalStyle`
  div {
    --p-interactive: ${theme.colors.primary.hex} !important;
  }

  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 1.4rem;
    font-family: 'Roboto', sans-serif;
  }

  .Polaris-Frame {
    background-color: ${theme.colors.backgound.hex};
  }

  .Polaris-Banner {
    .Polaris-Heading {
      font-size: 17px;
      font-weight: 600;
      line-height: 24px;
    }
  }

  .Polaris-Header-Title{
    font-size: 2.8rem;
    line-height: 3.2rem;
  }

  .Polaris-Heading, .Polaris-SkeletonPage__Title {
    font-size: 26px;
    font-weight: normal;
  }

  .Polaris-Link, a {
    color: ${theme.colors.givzGreen.hex};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      color: ${theme.colors.givzGreenDark.hex}
    }
  }


  .Polaris-RadioButton__Input {
    &:checked + .Polaris-RadioButton__Backdrop {
      border-color: #0B2327;

      &:before {
        background-color: #0B2327
      }
    }
  }

  .Polaris-Tabs__Wrapper {
    border-bottom: none;
  }

  .Polaris-PageActions {
    border-top: 2px solid ${theme.colors.secondaryLight.hex};
  }

  .Polaris-TextField__Segment {
    background: none;
    margin-bottom: 0;
  }

  .Polaris-TextField__Spinner {
    align-self: center;
  }


  .Polaris-TextStyle--variationNegative {
    color: ${theme.colors.destructive.hex};
  }

  .Polaris-ProgressBar__Indicator {
    background-color: ${theme.colors.primary.hex}
  }

  .Polaris-Badge {
    padding: 0.5rem 1.1rem;
  }

  .Polaris-Button {
    border-radius: 0;
    background: none;

    &:hover {
      background-image: linear-gradient(rgba(0, 0, 0, 0.2) 0 0);
    }
  }

  .Polaris-Button--primary, .Polaris-Button--primary:hover {
    background-color: ${theme.colors.primary.hex};
    border: 2px solid ${theme.colors.font.primary.hex};
    color: ${theme.colors.font.primary.hex};
  }

  .Polaris-Button--secondary {
    border: 1px solid ${theme.colors.secondary.hex};
  }

  .Polaris-Button--destructive, .Polaris-Button--destructive:hover {
    background-color: ${theme.colors.destructive.hex};
    color: #fff;
  }

  .Polaris-DataTable__Cell {
    white-space: normal;
    color: ${theme.colors.font.primary.hex};
    font-size: 12px
  }

  .Polaris-DataTable__Cell .Polaris-Link{
    white-space: normal;
    color: ${theme.colors.font.primary.hex};
    font-weight: 400;

    .Polaris-Icon svg {
      fill: #AEB4B9;
    }
  }

  .Polaris-DataTable--hoverable:hover .Polaris-Link{
    text-decoration: underline;
  }

  .Polaris-DataTable__Cell a {
    color: ${theme.colors.font.primary.hex};
  }

  .Polaris-DatePicker__Day:hover {
    background: ${theme.colors.primary.hex};
    color: #000;
    outline: 0.1rem solid transparent;
  }

  .Polaris-DatePicker__Day--selected {
    color: #000;
  }

  .Polaris-DataTable__Cell--header{
    font-size: 14px;
  }

  .Polaris-DataTable__Cell--header, .Polaris-DataTable__Cell--firstColumn{
    font-weight: 500;
  }

  .Polaris-DataTable__Cell  .Polaris-Badge {
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
  }

  .Polaris-DataTable__Cell--firstColumn .Polaris-Link{
    font-weight: 500;
  }

  .Polaris-Frame__ContextualSaveBar{
    top: 41px;
    z-index: 99;
  }

`;

export default GlobalStyle;
